import { forwardRef } from 'react';
import Box from '@mui/material/Box';
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import type { StepIconProps } from '@mui/material/StepIcon';

import { IconCheck } from '@/components/icon/tabler/IconCheck';
import { IconAlertTriangle } from '@/components/icon/tabler/IconAlertTriangle';
import { controlTokens, surfaceTokens } from '@/theme/themePrimitives';

/** The theme supplies the checkbox frame; there must be no second SVG border. */
export const EmptyCheckboxIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} />
));
EmptyCheckboxIcon.displayName = 'EmptyCheckboxIcon';

/** Retains step number/control geometry; only completion and error are glyphs. */
export function OutlineStepIcon({ active, completed, error, icon, className }: StepIconProps) {
  if (error) return <IconAlertTriangle className={className} color="error" />;
  if (completed) return <IconCheck className={className} color="success" />;
  return (
    <Box
      component="span"
      className={className}
      aria-hidden="true"
      sx={{
        width: 24,
        height: 24,
        border: '1px solid',
        borderColor: active ? controlTokens.primary : surfaceTokens.borderField,
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: active ? controlTokens.primary : 'text.secondary',
        bgcolor: active ? 'action.selected' : 'transparent',
        fontSize: 12,
      }}
    >
      {icon}
    </Box>
  );
}
